import React from "react";
import { twMerge } from "tailwind-merge";
import { IconType } from "react-icons";
import Switch from "./Switch";

export interface OptionToggleRowProps {
  icon: IconType | React.ReactNode;
  iconClassName?: string;
  title: React.ReactNode;
  titleBadge?: React.ReactNode;
  description?: React.ReactNode;
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const OptionToggleRow: React.FC<OptionToggleRowProps> = ({
  icon,
  iconClassName,
  title,
  titleBadge,
  description,
  enabled,
  onChange,
  disabled = false,
  className,
}) => {
  const iconNode =
    typeof icon === "function"
      ? React.createElement(icon as IconType, {
          className: twMerge("h-5 w-5 shrink-0 text-gray-400", iconClassName),
          "aria-hidden": true,
        })
      : icon;

  const heading = (
    <p className="text-sm font-semibold text-gray-900">{title}</p>
  );

  return (
    <div
      className={twMerge(
        "flex items-center justify-between gap-4 py-4",
        className
      )}
    >
      <div className="flex min-w-0 items-start gap-3">
        <span className="mt-0.5 flex shrink-0">{iconNode}</span>
        <div className="min-w-0">
          {titleBadge ? (
            <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
              {heading}
              {titleBadge}
            </div>
          ) : (
            heading
          )}
          {description != null && (
            <p className="mt-0.5 text-xs text-gray-500">{description}</p>
          )}
        </div>
      </div>
      <Switch
        checked={enabled}
        onChange={onChange}
        disabled={disabled}
        aria-label={typeof title === "string" ? title : undefined}
      />
    </div>
  );
};

export default OptionToggleRow;
